import { clsx, } from 'clsx';
import { twMerge, } from 'tailwind-merge';

/*
  this utility is used to merge existing class="" css on ui components with variants css

  eg: cn(buttonVariants({intent: props.variant}), props.class)
      variant CSS merged with existing class css on ui component
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
